import React from "react";

const fmt = (k) => {
  if (k.value === null || k.value === undefined) return "—";
  if (k.format === "pct") return `${k.value}%`;
  if (k.format === "decimal") return `${k.value}`;
  if (typeof k.value === "number") return k.value.toLocaleString();
  return String(k.value);
};

export const ReportKpiCards = ({ kpis = [] }) => (
  <div data-testid="report-kpi-cards" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
    {kpis.map((k) => (
      <div
        key={k.key}
        data-testid={`kpi-${k.key}`}
        className="rounded-xl border border-slate-200 bg-white p-4 hover:shadow-sm transition-shadow"
      >
        <div className="text-[10px] uppercase tracking-wider font-medium text-slate-500">
          {k.label}
        </div>
        <div className="mt-1.5 text-2xl font-bold text-slate-900 tracking-tight tabular-nums">
          {fmt(k)}
        </div>
      </div>
    ))}
  </div>
);

export default ReportKpiCards;
